import { createReducer, on } from '@ngrx/store';
import { LandingPage } from '../../models';
import * as pageActions from '../actions/landing-pages.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';

export interface LandingPagesState {
  entities: { [slug: string]: LandingPage };
  loaded: string[];
  loading: string[];
  error?: any;
}

export const initialState: LandingPagesState = {
  entities: {},
  loaded: [],
  loading: [],
};

export const landingPageReducer = createReducer(
  initialState,
  on(pageActions.LoadLandingPages, (state: LandingPagesState) => {
    return {
      ...state,
      loading: [],
    };
  }),
  on(pageActions.LoadLandingPagesSuccess, (state: LandingPagesState, { landingPages }) => {
    const entities = ToEntities(landingPages, 'slug', state.entities);
    return {
      ...state,
      entities,
      loading: [],
      loaded: landingPages.map(page => page.slug.toLowerCase().trim()),
    };
  }),
  on(pageActions.LoadLandingPagesFail, (state: LandingPagesState, { error }) => {
    return {
      ...state,
      loading: [],
      loaded: [],
      error,
    };
  }),
  on(pageActions.LoadLandingPageBySlug, (state: LandingPagesState, { slug }) => {
    slug = slug?.toLowerCase().trim();
    return {
      ...state,
      loading: [...state.loading, slug],
    };
  }),
  on(pageActions.LoadLandingPageBySlugSuccess, (state: LandingPagesState, { page }) => {
    const entities = { ...state.entities, [page.slug.toLowerCase().trim()]: page };
    return {
      ...state,
      entities,
      loading: state.loading.filter(slug => slug !== page.slug.toLowerCase().trim()),
      loaded: [...state.loaded, page.slug.toLowerCase().trim()],
    };
  }),
  on(pageActions.LoadLandingPageBySlugFail, (state: LandingPagesState, { error, slug }) => {
    slug = slug?.toLowerCase().trim();
    return {
      ...state,
      loading: state.loading.filter(slug => slug !== slug),
      loaded: state.loaded.filter(slug => slug !== slug),
      error,
    };
  })
);

export const getLandingPagesEntities = (state: LandingPagesState) => state.entities;
export const getLandingPagesLoading = (state: LandingPagesState) => state.loading;
export const getLandingPagesLoaded = (state: LandingPagesState) => state.loaded;
